module.exports = __webpack_public_path__ + "img/chatbot_pattern.f5839e5f.png";